import api from '../services/api'

export const cockpitSkills = [
  '3cb24cd9-5021-4224-b491-5c6400838295',
  'a19a6920-62b6-4d51-8861-2c887e6ebbf6',
  '4d3449ae-5fd9-4410-95d6-66d2b0a5d8d8',
  '21db4574-9ca4-4918-ab10-8b21b3ce5564',
  '65ba5c52-c8bd-4d9e-877a-a762f6df7f8b',
  '05622b65-7457-4a2d-b074-e423490912ae',
  '6e88ec8b-c005-4e23-8d72-c5a4aa5be726',
  '18593ed4-b43b-4bda-9073-bf5444e0d34b',
  'ae69eaa1-31d2-4404-b973-e4cac12d0830',
  '303d2096-7abc-453e-a989-b01c1fc21565',
  'd86c2155-e90b-495f-bd6d-e3c7734a8204',
  '37e09cd3-e341-4144-a189-02aaa3a674f9',
  '4fa829a6-ba64-47d3-8454-08333f0257a3',
  'c2a994f8-832c-4f3d-b8bc-719e010bc855',
  'e702ac69-0257-4ec3-972f-377fa6f3db67',
  'fa0d3059-13c2-4e3a-8adc-342f1c5f8fb8',
  'a19a6920-62b6-4d51-8861-2c887e6ebbf6',
  '8d2b06d1-55f2-4bf8-8b8d-3dba36872beb',
  '3cb24cd9-5021-4224-b491-5c6400838295',
  '65ba5c52-c8bd-4d9e-877a-a762f6df7f8b',
  '6e88ec8b-c005-4e23-8d72-c5a4aa5be726',
  '6f9a5778-ed86-4515-b1f1-f89bd6f87d05',
  '05622b65-7457-4a2d-b074-e423490912ae',
  '70e6016d-a49d-4688-9852-3c339f28b083',
  '710acb1b-563e-47ec-8875-106915cc1062',
  'b9b32522-485c-4b82-9451-525b46ebf4bd',
  'f8f8a158-2d60-4115-9cac-37ef41f6effe',
]

export const cockpit = (body, newCv = null, oldCv = null, user = null) => {
  let leaving = []

  try {
    if (!body) {
      const newCvIds = newCv
        .filter((e) => e.status === 'active' || e.status === 'inactive')
        .map((e) => e.conversationId)

      const oldCvIds = Object.entries(oldCv)
        .filter((e) => e[1].status === 'active' || e[1].status === 'inactive')
        .map((e) => e[0])

      const arriving = newCvIds.filter((e) => !oldCvIds.includes(e))
      leaving = oldCvIds.filter((e) => !newCvIds.includes(e))

      const data = []

      if (arriving.length > 0) {
        arriving.map((e) => {
          const currCv = newCv.find((el) => el?.conversationId === e)
          const isValid = cockpitSkills.includes(currCv?.skillId)

          if (isValid) {
            data.push({
              conversationId: e,
              nomeSolicitante: currCv?.consumer?.name,
              arriving: true,
              matricula: user?.extra_matricula,
            })
          }
        })
      }

      if (leaving.length > 0) {
        leaving.map((e) => {
          const currCv = oldCv?.[e]
          const isValid = cockpitSkills.includes(currCv?.skillId)

          if (isValid) {
            data.push({
              conversationId: e,
              nomeSolicitante: currCv?.consumer?.name,
              arriving: false,
              matricula: user.extra_matricula,
            })
          }
        })
      }
      body = data
    }
    if (body?.length > 0) {
      body.map(async (e) => {
        await api.post('/cockpit', e)
      })
    }
  } catch (error) {
    console.log('COCKPIT ERROR!', error)
  }
  return leaving
}
